import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import apiClient from "../utils/axios";
import { USER } from "../config/api";
import toast from "react-hot-toast";

function OrderPage() {
  const [order, setOrder] = useState(null);
  const [orderItems, setOrderItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);

  const token = localStorage.getItem("token");
  const Navigate = useNavigate();

  // Fetch pending order
  const fetchOrder = async () => {
    try {
      const { data } = await apiClient.get(USER.PENDING_ORDER);
      if (data.order) {
        setOrder(data.order);
        setOrderItems(data.items);
        const totalAmount = data.items.reduce(
          (sum, item) => sum + item.price * item.quantity,
          0
        );
        setTotal(totalAmount);
      } else {
        setOrder(null);
        setOrderItems([]);
        setTotal(0);
      }
    } catch (err) {
      console.error("Error fetching pending order:", err);
      toast.error(
        err.response?.data?.message ||
          err.message ||
          "Failed to fetch pending order"
      );
    }
  };

  useEffect(() => {
    fetchOrder();
  }, []);

  // Update quantity locally
  const updateQty = (id, type) => {
    const updatedItems = orderItems
      .map((item) =>
        item._id === id
          ? {
              ...item,
              quantity: type === "inc" ? item.quantity + 1 : item.quantity - 1,
            }
          : item
      )
      .filter((item) => item.quantity > 0);

    setOrderItems(updatedItems);
    const newTotal = updatedItems.reduce(
      (sum, item) => sum + item.price * item.quantity,
      0
    );
    setTotal(newTotal);
  };

  // Make payment
  const makeCashPayment = async () => {
    setLoading(true);
    try {
      const { data } = await apiClient.post(USER.PAY_ORDER, {
        amount: total,
        orderId: order._id,
        type: "cash",
      });

      if (data.success) {
        toast.success("Cash payment request sent to manager!");
        fetchOrder();
      } else {
        toast.error(data.message || "Could not process cash payment!");
      }
    } catch (err) {
      console.error("Cash Payment error:", err);
      toast.error(
        err.response?.data?.message || err.message || "Cash payment failed"
      );
    } finally {
      setLoading(false);
    }
  };
  // Make payment
  const makePayment = async () => {
    setLoading(true);
    try {
      const { data } = await apiClient.post(USER.PAY_ORDER, {
        amount: total,
        orderId: order._id,
        type: "online",
      });

      if (!data.success) {
        toast.error("Could not start payment!");
        return;
      }

      // 2. Load Razorpay SDK
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.async = true;
      document.body.appendChild(script);

      script.onload = () => {
        const options = {
          key: "rzp_test_RevaM903BQ1ytF",
          amount: data.amount,
          currency: data.currency,
          name: "My POS System",
          description: "Payment",
          order_id: data.orderId, // Razorpay order ID
          handler: async (response) => {
            try {
              toast.success("Payment Successful! Order will be processed.");
              Navigate("/");
            } catch (err) {
              toast.error("Payment completed but verification failed");
            }
          },
          prefill: {
            name: "Customer",
            email: "customer@example.com",
            contact: "9999999999",
          },
          theme: {
            color: "#3399cc",
          },
        };

        const rzp = new window.Razorpay(options);
        rzp.open();
      };
    } catch (err) {
      console.error("Payment error:", err);
      toast.error(
        err.response?.data?.message || err.message || "Payment failed"
      );
    } finally {
      setLoading(false);
    }
  };
  return (
    <div
      style={{
        backgroundColor: "#121212",
        color: "#e0e0e0",
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        paddingTop: "50px",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      }}
    >
      <div
        style={{
          width: "700px",
          backgroundColor: "#1e1e2a",
          borderRadius: "12px",
          padding: "30px",
          boxShadow: "0 5px 20px rgba(0,0,0,0.5)",
        }}
      >
        <h2
          style={{ textAlign: "center", marginBottom: "25px", color: "#fff" }}
        >
          Pending Payment
        </h2>

        <div style={{ marginBottom: "20px" }}>
          {orderItems.map((item) => (
            <div
              key={item._id}
              style={{
                display: "flex",
                justifyContent: "space-between",
                padding: "8px 0",
                borderBottom: "1px solid #333",
                fontSize: "16px",
              }}
            >
              <div
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <span>{item.menu_item.name}</span>

                <div
                  style={{
                    display: "flex",
                    background: "#333",
                    padding: "3px 10px",
                    borderRadius: "6px",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  <button
                    onClick={() => updateQty(item._id, "dec")}
                    style={{
                      border: "none",
                      background: "transparent",
                      color: "white",
                      fontSize: "20px",
                      cursor: "pointer",
                    }}
                  >
                    −
                  </button>

                  <span style={{ color: "white", fontSize: "16px" }}>
                    {item.quantity}
                  </span>

                  <button
                    onClick={() => updateQty(item._id, "inc")}
                    style={{
                      border: "none",
                      background: "transparent",
                      color: "white",
                      fontSize: "20px",
                      cursor: "pointer",
                    }}
                  >
                    +
                  </button>
                </div>

                <span>Rs.{(item.price * item.quantity).toFixed(2)}</span>
              </div>

              <span>
                {item.menu_item.name} x{item.quantity}
              </span>
              <span>Rs.{(item.price * item.quantity).toFixed(2)}</span>
            </div>
          ))}
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            fontSize: "18px",
            fontWeight: "bold",
            marginBottom: "25px",
            paddingTop: "10px",
            borderTop: "1px solid #333",
          }}
        >
          <span>Total</span>
          <span>Rs.{total.toFixed(2)}</span>
        </div>
        <div className="row justify-content-between g-1">
          <button
            className="col-md-5 col-sm-12"
            onClick={makeCashPayment}
            disabled={loading}
            style={{
              padding: "7px 0",
              borderRadius: "8px",
              border: "none",
              backgroundColor: "#28a745",
              color: "#fff",
              fontSize: "18px",
              fontWeight: "bold",
              cursor: "pointer",
              transition: "all 0.2s",
              marginTop: "10px",
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "#218838";
              e.target.style.transform = "scale(1.03)";
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "#28a745";
              e.target.style.transform = "scale(1)";
            }}
          >
            {loading ? "Processing..." : "Pay In Cash"}
          </button>
          <button
            className="col-md-5 col-sm-12"
            onClick={makePayment}
            disabled={loading}
            style={{
              padding: "7px 0",
              borderRadius: "8px",
              border: "none",
              backgroundColor: "#28a745",
              color: "#fff",
              fontSize: "18px",
              fontWeight: "bold",
              cursor: "pointer",
              transition: "all 0.2s",
              marginTop: "10px",
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "#218838";
              e.target.style.transform = "scale(1.03)";
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "#28a745";
              e.target.style.transform = "scale(1)";
            }}
          >
            {loading ? "Processing..." : "Pay Online"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default OrderPage;
